//=require _respond.min.js
//=require _jquery-1.11.0.min.js
//=require _jquery.easing.min.js
//=require _jquery.easing.compatibility.js
//=require _jquery.fs.shifter.min.js
//=require _jquery.fancybox.min.js
//=require _jquery-confirm.min.js
//=require _bootstrap-datepicker.min.js
//=require _bootstrap-datepicker.fr.min.js
//=require _owl.carousel.min.js
//=require _wow.min.js
//=require _lazyload.min.js
//=require _framework.js
//=require _general.js
